export default __webpack_public_path__ + "59f1a122fa7524cd655d9168f041e707.png";